module.exports = __webpack_public_path__ + "img/tickets-visual.ee2b543a.svg";